<div class="filter"
     id="filterOut"
     #filter
     (click)="close($event)">

  <form class="filter__box"
        (keydown.enter)="applyFilter()"
        id="filterBox"
        *ngIf="filters && filters.length > 0"
        [formGroup]="formFilter">
    <div fxLayout="column"
         fxLayoutAlign="space-between start"
         fxLayoutGap="24px"
         class="h-100 w-100">
      <div fxLayout="column"
           class="w-100 m-0 p-4 filter__box-title"
           fxLayoutAlign="space-between start">

        <div fxLayout="row layout-wrap"
             fxLayoutAlign="space-between center"
             class="w-100">

          <h1>Filtros</h1>

          <button mat-mini-fab
                  class="filter__box-button"
                  color="primary"
                  (click)="close()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-divider class="w-100 mb-3"></mat-divider>
        </div>

        <button mat-button
                class="filter__button-clear"
                color="primary"
                class="mb-2"
                fxFlexAlign="end"
                (click)="clearFilters()">
          Limpar Filtros
        </button>

        <div *ngFor="let itemFilter of filters"
             class="w-100">

          <span *ngIf="itemFilter.filterType == filterTypeEnum.CHECKBOX">
            <span fxFlex="100%"
                  class="pb-4">
              <mat-checkbox color="primary"
                            [formControlName]="itemFilter.param">{{itemFilter.label}}</mat-checkbox>
            </span>
          </span>

          <span *ngIf="itemFilter.filterType == filterTypeEnum.CURRENCY">
            <mat-form-field appearance="outline"
                            fxFlex="100%">
              <mat-label>{{itemFilter.label}}</mat-label>
              <input autocomplete="off"
                     currencyMask
                     matInput
                     type="text"
                     [formControlName]="itemFilter.param" />
              <mat-icon class="filter__button-clear"
                        *ngIf="this.formFilter.get(itemFilter.param).value && !!!itemFilter.disabled"
                        (click)="this.formFilter.get(itemFilter.param).setValue('')"
                        matSuffix>clear</mat-icon>
            </mat-form-field>
          </span>

          <span *ngIf="itemFilter.filterType == filterTypeEnum.DATE">
            <app-date-input [label]="itemFilter.label"
                            formControlName="{{itemFilter.param}}"
                            [clear]="clearFilterDate"
                            [fControl]="formFilter.controls[itemFilter.param]">
            </app-date-input>
          </span>

          <span *ngIf="itemFilter.filterType == filterTypeEnum.NUMBER">
            <mat-form-field appearance="outline"
                            fxFlex="100%">
              <mat-label>{{itemFilter.label}}</mat-label>
              <input autocomplete="off"
                     matInput
                     type="number"
                     [mask]="itemFilter.mask ? itemFilter.mask : false"
                     [formControlName]="itemFilter.param" />
              <mat-icon class="filter__button-clear"
                        *ngIf="this.formFilter.get(itemFilter.param).value && !!!itemFilter.disabled"
                        (click)="this.formFilter.get(itemFilter.param).setValue('')"
                        matSuffix>clear</mat-icon>
            </mat-form-field>
          </span>

          <span *ngIf="(itemFilter.filterType == filterTypeEnum.SELECT)">
            <mat-form-field appearance="outline"
                            fxFlex="100%">
              <mat-label>{{itemFilter.label}}</mat-label>
              <mat-icon class="autocomplete-icon-select"
                        *ngIf="!this.formFilter.get(itemFilter.param).value"
                        matSuffix>keyboard_arrow_down</mat-icon>
              <mat-icon class="autocomplete-icon-select"
                        *ngIf="this.formFilter.get(itemFilter.param).value && !!!itemFilter.disabled"
                        (click)="this.formFilter.get(itemFilter.param).setValue('')"
                        matSuffix>clear</mat-icon>
              <mat-select [formControlName]="itemFilter.param">
                <mat-option [value]="type"
                            *ngFor="let type of itemFilter.selectData">
                  {{type.descricao}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </span>

          <span *ngIf="itemFilter.filterType == filterTypeEnum.TEXT">
            <mat-form-field appearance="outline"
                            fxFlex="100%">
              <mat-label>{{itemFilter.label}}</mat-label>
              <input autocomplete="off"
                     matInput
                     type="text"
                     [dropSpecialCharacters]="!itemFilter.sendSpecialCharacters"
                     [formControlName]="itemFilter.param"
                     [mask]="itemFilter.mask ? itemFilter.mask : false" />
              <mat-icon class="filter__button-clear"
                        *ngIf="this.formFilter.get(itemFilter.param).value && !!!itemFilter.disabled"
                        (click)="this.formFilter.get(itemFilter.param).setValue('')"
                        matSuffix>clear</mat-icon>
            </mat-form-field>
          </span>

          <span *ngIf="itemFilter.filterType == filterTypeEnum.AUTOCOMPLETE">
            <app-constant-autocomplete [items]="itemFilter.selectData"
                                        [fControl]="formFilter.controls[itemFilter.param]"
                                        [label]="itemFilter.label">
            </app-constant-autocomplete>
          </span>

          <span *ngIf="itemFilter.filterType == filterTypeEnum.CFCS">
            <app-cfc-autocomplete class="auto-complete"
                                  [cfcValue]="itemFilter.cfcValue"
                                  [formControlName]="itemFilter.param"
                                  [fControl]="formFilter.controls[itemFilter.param]">
            </app-cfc-autocomplete>
          </span>

          <span *ngIf="itemFilter.filterType == filterTypeEnum.PERSON">
            <app-person-autocomplete class="auto-complete"
                                     [formControlName]="itemFilter.param"
                                     [fControl]="formFilter.controls[itemFilter.param]"
                                     [itemProperty]="itemFilter.itemProperty"
                                     [personType]="itemFilter.personType"
                                     [label]="itemFilter.label">
            </app-person-autocomplete>
          </span>

          <span *ngIf="itemFilter.filterType == filterTypeEnum.BOOLEAN">
            <mat-form-field appearance="outline"
                            fxFlex="100%">
              <mat-label>{{itemFilter.label}}</mat-label>
              <mat-icon class="autocomplete-icon-select"
                        *ngIf="this.formFilter.get(itemFilter.param).value === ''"
                        matSuffix>keyboard_arrow_down</mat-icon>
              <mat-icon class="autocomplete-icon-select"
                        *ngIf="this.formFilter.get(itemFilter.param).value !== ''"
                        (click)="this.formFilter.get(itemFilter.param).setValue('')"
                        matSuffix>clear</mat-icon>
              <mat-select [formControlName]="itemFilter.param">
                <mat-option [value]="'true'"> SIM </mat-option>
                <mat-option [value]="'false'"> NÃO </mat-option>
              </mat-select>
            </mat-form-field>
          </span>

        </div>
      </div>

      <div class="filter__button w-100 py-2"
           color="primary"
           (click)="applyFilter(true)">
        FILTRAR
      </div>
    </div>
  </form>
</div>
